import type { GetIssueAssessmentAuditByIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import { GetIssueAssessmentAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

import type { AuditLogQueryResult } from './auditLogQueryResult';

type UseGetIssueAssessmentAuditByIdArgs = { id: string };

export const useGetIssueAssessmentAuditById = createQueryHook<
  UseGetIssueAssessmentAuditByIdArgs,
  GetIssueAssessmentAuditByIdResponseRow[],
  AuditLogQueryResult<
    'issue_assessment_audit',
    GetIssueAssessmentAuditByIdResponseRow
  >
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getIssueAssessmentAuditById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ issue_assessment_audit: data }),
  graphqlDocument: GetIssueAssessmentAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
